import React, { useContext, useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import { usePlatformStatus } from "../context/PlatformStatusProvider";
import PlatformStatusBanner from "../customComponents/PlatformStatusBanner";
import DepositDeclarationBanner from "../customComponents/DepositDeclarationBanner";
import MaintenancePage from "../ui/Pages/MaintenancePage";
import SignupPage from "../../src/ui/Pages/SignupPage";
import UserHeader from "../customComponents/UserHeader";
import Footer from "../customComponents/Footer";
import LandingPage from "../ui/Pages/LandingPage";
import LoginPage from "../ui/Pages/LoginPage";
import ForgotPassword from "../ui/Pages/ForgotPassword";
import ProfilePage from "../ui/Pages/ProfilePage";
import ComingSoonPage from "../ui/Pages/ComingSoonPage";
import AuthHeader from "../customComponents/AuthHeader";
import "../customComponents/AuthHeader/auth-header-tools.css";
import Trade from "../ui/Pages/TradePage";
import Margin from "../ui/Pages/margin";
import FuturesTrade from "../ui/Pages/futures_trade";
import Market from "../ui/Pages/Market";
import NotificationPage from "../ui/Pages/NotificationPage";
import { ProfileContext } from "../context/ProfileProvider";
import Termsofuse from "../ui/Pages/Termsofuse";
import AmlPolicy from "../ui/Pages/AmlPolicy";
import Contactus from "../ui/Pages/Contactus";
import FeesPage from "../ui/Pages/FeesPage";
import BugBounty from "../ui/Pages/BugBounty";
import ListCoin from "../ui/Pages/ListCoin";
import ReferralPageNew from "../ui/Pages/Referral";
import TokenPage from "../ui/Pages/TokenPage";
import EarnNewPage from "../ui/Pages/EarnNew";
import SecuritySystem from "../ui/Pages/SecuritySystem";
import RefrealList from "../ui/Pages/RefrealList";
import {
  LicensePage, LawEnforcementPage,
  SquarePage, UserFeedbackPage, SubmitRequestPage,
  DevelopersPage, AffiliateProgramPage, WhyAgcePage,
} from "../ui/Pages/FooterPages";
import DownloadAppPage from "../ui/Pages/FooterPages/DownloadAppPage";
import OtcTradeLanding from "../ui/Pages/OtcDesk/OtcTradeLanding";
import OtcTradeDesk from "../ui/Pages/OtcTrade/OtcTradeDesk";
import OtcTradeHistory from "../ui/Pages/OtcTrade/OtcTradeHistory";
import BlogList from "../ui/Pages/Blog/BlogList";
import AboutUs from "../ui/Pages/AboutUs";
import AboutCompany from "../ui/Pages/AboutUs/Company";
import AboutTeam from "../ui/Pages/AboutUs/Team";
import ProofOfReserves from "../ui/Pages/ProofOfReserves";
import MobileChart from "../ui/Pages/MobileChart";
import CareersPage from "../ui/Pages/Careers";
import NewSecurity from "../ui/Pages/NewSecurity";
import AirDropPage from "../ui/Pages/Airdrops";
import AirdropDetails from "../ui/Pages/Airdrops/AirdropDetails";
import MobileFuturesChart from "../ui/Pages/MobileFuturesChart";
import BlogDetails from "../ui/Pages/Blog/BlogDetails";
import SettingsPage from "../ui/Pages/SettingsPage";
import NotificationSettingsPage from "../ui/Pages/NotificationSettingsPage";
import SupportPage from "../ui/Pages/Support";
import TwofactorPage from "../ui/Pages/TwofactorPage";
import PasskeyPage from "../ui/Pages/PasskeyPage";
import SmsVerification from "../ui/Pages/TwofactorPage/smsVerification";
import EmailVerification from "../ui/Pages/TwofactorPage/emailVerification";
import AntiPhishing from "../ui/Pages/TwofactorPage/antiPhishing";
import EmergencyContact from "../ui/Pages/TwofactorPage/emergencyContact";
import AccountConnections from "../ui/Pages/TwofactorPage/accountConnections";
import ChangeLoginPassword from "../ui/Pages/TwofactorPage/changeLoginPassword";
import SetFundPassword from "../ui/Pages/TwofactorPage/setFundPassword";
import AuthorizedDevices from "../ui/Pages/TwofactorPage/authorizedDevices";
import SecurityLogs from "../ui/Pages/TwofactorPage/securityLogs";
import DisableAccount from "../ui/Pages/TwofactorPage/disableAccount";
import CloseAccount from "../ui/Pages/TwofactorPage/closeAccount";
import ThirdPartyAccess from "../ui/Pages/TwofactorPage/thirdPartyAccess";
import BindGoogleAuthenticator from "../ui/Pages/TwofactorPage/bindGoogleAuthenticator";
import ActivitylogPage from "../ui/Pages/ActivitylogPage";
import MyTicketsPage from "../ui/Pages/MyTicketsPage";
import ApiKeyManagement from "../ui/Pages/ApiKeyManagement";
import CreateApiKey from "../ui/Pages/ApiKeyManagement/CreateApiKey";
import CreateTicketsPage from "../ui/Pages/CreateTicketsPage/index";
import Dashboard from "../ui/Pages/Dashboard";
import AssetOverview from "../ui/Pages/AssetOverview";
import WalletTypeRoute from "../ui/Pages/WalletPage/WalletTypeRoute";
import SpotOrders from "../ui/Pages/Order/SpotOrders";
import SpotOpenOrders from "../ui/Pages/Order/SpotOpenOrders";
import SpotPositionHistory from "../ui/Pages/Order/SpotPositionHistory";
import TransactionHistory from "../ui/Pages/TransactionHistory";
import OpenOrders from "../ui/Pages/Order/OpenOrders";
import FuturesOpenOrders from "../ui/Pages/Order/FuturesOpenOrders";
import FuturesOrderHistory from "../ui/Pages/Order/FuturesOrderHistory";
import PositionOrders from "../ui/Pages/Order/PositionOrders";
import PositionHistory from "../ui/Pages/Order/PositionHistory";
import FuturesTradeHistory from "../ui/Pages/Order/FuturesTradeHistory";
import OptionsOpenOrders from "../ui/Pages/Order/OptionsOpenOrders";
import OptionsOrderHistory from "../ui/Pages/Order/OptionsOrderHistory";
import OptionsTradeHistory from "../ui/Pages/Order/OptionsTradeHistory";
import OptionsPositionHistory from "../ui/Pages/Order/OptionsPositionHistory";
import StakingOrders from "../ui/Pages/Order/StakingOrders";
import StakingOrderHistory from "../ui/Pages/Order/StakingOrderHistory";
import ConvertOrders from "../ui/Pages/Order/ConvertOrders";
import OtcOrders from "../ui/Pages/Order/OtcOrders";
import CopyTradingOrders from "../ui/Pages/Order/CopyTrading";
import FiatAssetOrder from "../ui/Pages/Order/FiatAssetOrder";
import DepositHistory from "../ui/Pages/Order/DepositHistory";
import DepositDeclaration from "../ui/Pages/Order/DepositDeclaration";
import WithdrawHistory from "../ui/Pages/Order/WithdrawHistory";
import MarginOrders from "../ui/Pages/Order/MarginOrders";
import MarginOrderHistory from "../ui/Pages/Order/MarginOrderHistory";
import MarginPositionHistory from "../ui/Pages/Order/MarginPositionHistory";
import MarginTradeHistory from "../ui/Pages/Order/MarginTradeHistory";
import MarginTransferHistory from "../ui/Pages/Order/MarginTransferHistory";
import MarginBorrowingHistory from "../ui/Pages/Order/MarginBorrowingHistory";
import LaunchpadOrders from "../ui/Pages/Order/Launchpad";
import Transfer from "../ui/Pages/Order/Transfer";
import Referral from "../ui/Pages/Order/Referral";
import QuickBuySell from "../ui/Pages/Order/QuickBuySell";
import SidebarDeposit from "../customComponents/SidebarDeposit";
import DepositPage from "../ui/Pages/DepositPage";
import DepositFiatPage from "../ui/Pages/DepositFiatPage";
import WithdrawFiatPage from "../ui/Pages/WithdrawFiatPage";
import WithdrawPage from "../ui/Pages/WithdrawPage";
import SecurityVerificationUnavailable from "../ui/Pages/WithdrawPage/SecurityVerificationUnavailable";
import MemePage from "../ui/Pages/MemePage";
import KycSubmittedPage from "../ui/Pages/KycPage/KycSubmittedPage";
import KycVaraModalHost from "../ui/Pages/KycVara";
import KYBVerification from "../ui/Pages/KYBVerification";
import KYBPending from "../ui/Pages/KYBVerification/KYBPending";
import KYBFailed from "../ui/Pages/KYBVerification/KYBFailed";
import KYBSuccess from "../ui/Pages/KYBVerification/KYBSuccess";

// import Earning from "../ui/Pages/Earning";
import Launchpad from "../ui/Pages/Launchpad";
import Swap from "../ui/Pages/Swap";
import RiskDisclosure from "../ui/Pages/RiskDisclosure";
import PrivacyDataProtectionPolicy from "../ui/Pages/PrivacyDataProtectionPolicy";
import PrivacyPolicy from "../ui/Pages/PrivacyPolicy";
import UserAgreement from "../ui/Pages/UserAgreement";
import UserTermsConditions from "../ui/Pages/UserTermsConditions";
import DeleteAccount from "../ui/Pages/DeleteAccount";
import ComplaintsHandlingProcedure from "../ui/Pages/ComplaintsHandlingProcedure";
import GeneralDisclaimer from "../ui/Pages/GeneralDisclaimer";
import StakingUserAgreement from "../ui/Pages/StakingUserAgreement";
import FAQSidebar from "../ui/Pages/FAQ/FAQSidebar";
import FAQ from "../ui/Pages/FAQ";
import RegistrationResult from "../ui/Pages/RegistrationResult";
import QuickBuySellHistory from "../ui/Pages/QuickBuySellHistory";
import InternalWalletTransHistory from "../ui/Pages/InternalWalletTransHistory";
import CrossMarginAccountPage from "../ui/Pages/CrossMarginAccountPage";
import CrossMargin from "../ui/Pages/cross_margin";
import EarningPlanHistory from "../ui/Pages/EarningPlanHistory";
import UsdMFutures from "../ui/Pages/FuturesAndOptions/UsdMFutures";
import BonusHistory from "../ui/Pages/Bonus History";
import AnnouncementList from "../ui/Pages/AnnouncmentManagement/AnnouncementList";
import AnnouncementDetails from "../ui/Pages/AnnouncmentManagement/AnnouncementDetails";
import Announcement from "../ui/Pages/AnnouncmentManagement/Announcement";
import LaunchpadHome from "../ui/Pages/Launchpad/LaunchpadHome";
import LaunchpadCoinPage from "../ui/Pages/Launchpad/LaunchpadCoinPage";
import LaunchpadTransation from "../ui/Pages/Launchpad/LaunchpadTransation";
import LaunchpadDetail from "../ui/Pages/Launchpad/LaunchpadDetail";
import ConvertPage from "../ui/Pages/ConvertPage/convert";
import BuySellPage from "../ui/Pages/BuySellPage";
import OptionsPage from "../ui/Pages/options";
import OptionsPnlAnalysisPage from "../ui/Pages/OptionsAccountPage/OptionsPnlAnalysisPage";
import SpotPnlAnalysisPage from "../ui/Pages/WalletPage/SpotPnlAnalysisPage";
import VipServices from "../ui/Pages/VipServices";
// import WaitList from "../ui/Pages/WaitList";
import StakingPage from "../ui/Pages/Staking";
import StakingDetail from "../ui/Pages/Staking/StakingDetail";
import CopyTradingPage from "../ui/Pages/CopyTrading";
import CopyTradingDetailPage from "../ui/Pages/CopyTradingDetail";
import SimpleEarn from "../ui/Pages/SimpleEarn";
import SoftStaking from "../ui/Pages/SoftStaking";
import ApiDocument from "../ui/Pages/ApiDocument";
import StraightPage from "../ui/Pages/Straight";
import FinancialInstitution from "../ui/Pages/FinancialInstitution";
import Infrastructure from "../ui/Pages/Infrastructure";


// P2p Routes
import P2pDashboard from "../ui/Pages/P2P/P2pDashboard";
import P2pOrderDetails from "../ui/Pages/P2P/P2pOrderDetails";
import P2pCreatePost from "../ui/Pages/P2P/P2pCreatePost";
import P2pMyAds from "../ui/Pages/P2P/P2pMyAds";
import P2pOrders from "../ui/Pages/P2P/P2pOrders";
import P2pProfile from "../ui/Pages/P2P/P2pProfile";
import P2pTradeOrder from "../ui/Pages/P2P/P2pTradeOrder";


const RedirectToAnnouncementList = () => {
  const { announce_title_id } = useParams();
  return <Navigate to={`/announcement/${announce_title_id}`} replace />;
};

const RedirectToAnnouncementDetails = () => {
  const { announce_title_id } = useParams();
  return <Navigate to={`/announcement/details/${announce_title_id}`} replace />;
};

const RedirectToFAQSidebar = () => {
  const location = useLocation();
  const stateCategory = location.state;
  return <Navigate to={`/help_center${stateCategory ? `/${stateCategory}` : ""}`} replace />;
};

const RedirectToHelpCenter = () => {
  const { category } = useParams();
  return <Navigate to={`/help_center${category ? `/${category}` : ""}`} replace />;
};

const RedirectToBlogDetails = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const qs = location.search?.slice(1) || "";
  const blogId = searchParams.get("id") || (qs.includes("=") ? "" : qs) || "";
  return <Navigate to={`/blogs${blogId ? `/${blogId}` : ""}`} replace />;
};

function Routing() {
  const location = useLocation();
  const [token, setToken] = useState(() =>
    typeof window !== "undefined" ? localStorage.getItem("token") : null
  );
  useEffect(() => {
    const sync = () => setToken(typeof window !== "undefined" ? localStorage.getItem("token") : null);
    window.addEventListener("agce-auth-token-changed", sync);
    return () => window.removeEventListener("agce-auth-token-changed", sync);
  }, []);
  useEffect(() => {
    setToken(typeof window !== "undefined" ? localStorage.getItem("token") : null);
  }, [location.pathname]);

  // Add 'home' class to body only on landing page
  useEffect(() => {
    const isHome = location.pathname === "/";
    document.body.classList.toggle("home", isHome);
    return () => {
      document.body.classList.remove("home");
    };
  }, [location.pathname]);
  const { userDetails } = useContext(ProfileContext);
  const { isFullMaintenance, loading } = usePlatformStatus();
  const isChartPage = location?.pathname?.includes('/chart') || location?.pathname?.includes('/futures-chart');
  const isWaitListPage = location.pathname === '/wait-list';
  const isMaintenancePage = location.pathname === '/maintenance';
  const isKycSubmittedCallbackPage = location.pathname === "/kyc-submitted";
  // Full maintenance: entire website down - show only maintenance page with image
  if (!loading && isFullMaintenance) {
    if (!isMaintenancePage) return <Navigate to="/maintenance" replace />;
    return <MaintenancePage />;
  }

  // No maintenance details page when only modules are scheduled - redirect /maintenance to home
  if (!loading && !isFullMaintenance && isMaintenancePage) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {!loading && <PlatformStatusBanner />}
      {!loading && <DepositDeclarationBanner />}
      <KycVaraModalHost token={token} userDetails={userDetails} />
      {isChartPage || isWaitListPage || isKycSubmittedCallbackPage ? null : token ? (
        <AuthHeader key={location.pathname} userDetails={userDetails} />
      ) : (
        <UserHeader key={location.pathname} />
      )}
      <Routes>
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/api-documentation" element={<ApiDocument />} />
        <Route
          path="/kyc-submitted"
          element={
            <KycSubmittedPage />

          }
        />
        {/* Hand-off address only: KycVaraModalHost opens the KYC modal and moves to the dashboard. */}
        <Route
          path="/kyc-verification"
          element={token ? null : (<Navigate to="/login" replace state={{ redirectTo: "/kyc-verification" }} />)}
        />
        <Route path="/create_api_key" element={token ? (<CreateApiKey />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile" element={token ? (<ProfilePage userDetails={userDetails} />) : (<Navigate to="/login" replace state={{ redirectTo: location.pathname }} />)} >
          <Route index path="dashboard" element={token ? (<Dashboard userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="api_keys" element={token ? (<ApiKeyManagement userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="asset_overview" element={token ? (<AssetOverview userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="staking" element={token ? (<StakingOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="cross_margin" element={token ? (<CrossMarginAccountPage />) : (<Navigate to="/login" replace />)} />
          <Route path="wallet/options/pnl-analysis" element={token ? (<OptionsPnlAnalysisPage />) : (<Navigate to="/login" replace />)} />
          <Route path="wallet/spot/pnl-analysis" element={token ? (<SpotPnlAnalysisPage />) : (<Navigate to="/login" replace />)} />
          <Route path="wallet/:walletType" element={token ? (<WalletTypeRoute />) : (<Navigate to="/login" replace />)} />
          {/* Orders rail lives under /user_profile/orders/* */}
          <Route path="orders">
            {/* Default orders page = Open Orders */}
            <Route index element={token ? (<OpenOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="swap_history" element={token ? (<QuickBuySellHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="spot_orders" element={token ? (<SpotOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="spot_order_history" element={token ? (<SpotOpenOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="spot_position_history" element={token ? (<SpotPositionHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="spot_open_orders" element={<Navigate to="/user_profile/orders/spot_orders" replace />} />
            <Route path="transaction_history" element={token ? (<TransactionHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="earning_plan_history" element={token ? (<EarningPlanHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="wallet_transfer_History" element={token ? (<InternalWalletTransHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="bonus_history" element={token ? (<BonusHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="open_orders" element={<Navigate to="/user_profile/orders" replace />} />
            <Route path="futures_open_orders" element={token ? (<FuturesOpenOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="futures_order_history" element={token ? (<FuturesOrderHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="position_orders" element={token ? (<PositionOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="position_history" element={token ? (<PositionHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="futures_trade_history" element={token ? (<FuturesTradeHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="options_open_orders" element={token ? (<OptionsOpenOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="options_order_history" element={token ? (<OptionsOrderHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="options_trade_history" element={token ? (<OptionsTradeHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="options_position_history" element={token ? (<OptionsPositionHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="staking_orders" element={token ? (<StakingOrderHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="convert_orders" element={token ? (<ConvertOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="otc_trade" element={token ? (<OtcTradeDesk />) : (<Navigate to="/login" replace />)} />
            <Route path="otc_orders" element={token ? (<OtcOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="otc_order_history" element={token ? (<OtcOrders userDetails={userDetails} initialTab="history" />) : (<Navigate to="/login" replace />)} />
            <Route path="copy_trading_orders" element={token ? (<CopyTradingOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="fiat_asset_order" element={token ? (<FiatAssetOrder userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="deposit_history" element={token ? (<DepositHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="deposit_history/:depositId" element={token ? (<DepositDeclaration />) : (<Navigate to="/login" replace />)} />
            <Route path="withdraw_history" element={token ? (<WithdrawHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="withdraw_history/:withdrawalId" element={token ? (<DepositDeclaration kind="withdrawal" />) : (<Navigate to="/login" replace />)} />
            <Route path="margin_orders" element={token ? (<MarginOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="margin_order_history" element={token ? (<MarginOrderHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="margin_position_history" element={token ? (<MarginPositionHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="margin_trade_history" element={token ? (<MarginTradeHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="margin_transfer_history" element={token ? (<MarginTransferHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="margin_borrowing_history" element={token ? (<MarginBorrowingHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="launchpad_orders" element={token ? (<LaunchpadOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="transfer" element={token ? (<Transfer userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="referral" element={token ? (<Referral userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
            <Route path="quick_buy_sell" element={token ? (<QuickBuySell userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />

          </Route>

          {/* Backward-compatible order URLs */}
          <Route path="open_orders" element={<Navigate to="orders" replace />} />
          <Route path="spot_orders" element={<Navigate to="orders/spot_orders" replace />} />
          <Route path="spot_order_history" element={<Navigate to="orders/spot_order_history" replace />} />
          <Route path="spot_position_history" element={<Navigate to="orders/spot_position_history" replace />} />
          <Route path="spot_open_orders" element={<Navigate to="orders/spot_orders" replace />} />
          <Route path="futures_open_orders" element={<Navigate to="orders/futures_open_orders" replace />} />
          <Route path="futures_order_history" element={<Navigate to="orders/futures_order_history" replace />} />
          <Route path="position_orders" element={<Navigate to="orders/position_orders" replace />} />
          <Route path="position_history" element={<Navigate to="orders/position_history" replace />} />
          <Route path="futures_trade_history" element={<Navigate to="orders/futures_trade_history" replace />} />
          <Route path="options_open_orders" element={<Navigate to="orders/options_open_orders" replace />} />
          <Route path="options_order_history" element={<Navigate to="orders/options_order_history" replace />} />
          <Route path="options_trade_history" element={<Navigate to="orders/options_trade_history" replace />} />
          <Route path="options_position_history" element={<Navigate to="orders/options_position_history" replace />} />
          <Route path="staking_orders" element={<Navigate to="orders/staking_orders" replace />} />
          <Route path="convert_orders" element={<Navigate to="orders/convert_orders" replace />} />
          <Route path="otc_orders" element={<Navigate to="orders/otc_orders" replace />} />
          <Route path="copy_trading_orders" element={<Navigate to="orders/copy_trading_orders" replace />} />
          <Route path="fiat_asset_order" element={<Navigate to="orders/fiat_asset_order" replace />} />
          <Route path="deposit_history" element={<Navigate to="orders/deposit_history" replace />} />
          <Route path="withdraw_history" element={<Navigate to="orders/withdraw_history" replace />} />
          <Route path="margin_orders" element={<Navigate to="orders/margin_orders" replace />} />
          <Route path="launchpad_orders" element={<Navigate to="orders/launchpad_orders" replace />} />
          <Route path="transfer" element={<Navigate to="orders/transfer" replace />} />
          <Route path="referral" element={<Navigate to="orders/referral" replace />} />
          <Route path="quick_buy_sell" element={<Navigate to="orders/quick_buy_sell" replace />} />
          <Route path="swap_history" element={<Navigate to="orders/swap_history" replace />} />
          <Route path="wallet_transfer_History" element={<Navigate to="orders/wallet_transfer_History" replace />} />
          <Route path="earning_plan_history" element={<Navigate to="orders/earning_plan_history" replace />} />
          <Route path="transaction_history" element={<Navigate to="orders/transaction_history" replace />} />
          <Route path="bonus_history" element={<Navigate to="orders/bonus_history" replace />} />
          <Route path="profile_setting" element={token ? (<SettingsPage />) : (<Navigate to="/login" replace />)} />
          <Route path="notification_settings" element={token ? (<NotificationSettingsPage />) : (<Navigate to="/login" replace />)} />
          {/* Old KYC page retired: its status call re-synced the login KYC from the old flow. */}
          <Route path="kyc" element={<Navigate to="/kyc-verification" replace />} />
          <Route path="kyb" element={token ? (<KYBVerification userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="kyb/pending" element={token ? (<KYBPending />) : (<Navigate to="/login" replace />)} />
          <Route path="kyb/progress" element={<Navigate to="/user_profile/kyb/pending" replace />} />
          <Route path="kyb/failed" element={token ? (<KYBFailed />) : (<Navigate to="/login" replace />)} />
          <Route path="kyb/success" element={token ? (<KYBSuccess />) : (<Navigate to="/login" replace />)} />
          <Route path="notification" element={token ? (<NotificationPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="launchpad_transactions" element={token ? (<LaunchpadTransation userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="security" element={token ? (<TwofactorPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="two_factor_autentication" element={<Navigate to="/user_profile/security" replace />} />
          <Route path="activity_logs" element={token ? (<ActivitylogPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="my_tickets" element={token ? (<MyTicketsPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="create_tickets" element={token ? (<CreateTicketsPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="swap" element={token ? (<Swap userDetails={userDetails} />) : <Navigate to="/login" replace />} />
          <Route path="support" element={token ? (<SupportPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
        </Route>

        {/* Standalone (no Profile sidebar) pages */}
        <Route path="/user_profile/security/passkey" element={token ? (<PasskeyPage />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/smsVerification" element={token ? (<SmsVerification />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/emailVerification" element={token ? (<EmailVerification />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/antiPhishing" element={token ? (<AntiPhishing />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/emergencyContact" element={token ? (<EmergencyContact />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/accountConnections" element={token ? (<AccountConnections />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/changeLoginPassword" element={token ? (<ChangeLoginPassword />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/setFundPassword" element={token ? (<SetFundPassword />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/authorizedDevices" element={token ? (<AuthorizedDevices />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/activeSessions" element={<Navigate to="/user_profile/security/authorizedDevices?tab=sessions" replace />} />
        <Route path="/user_profile/security/securityLogs" element={token ? (<SecurityLogs />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/disableAccount" element={token ? (<DisableAccount />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/closeAccount" element={token ? (<CloseAccount />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/thirdPartyAccess" element={token ? (<ThirdPartyAccess />) : (<Navigate to="/login" replace />)} />
        <Route path="/user_profile/security/bindGoogleAuthenticator" element={token ? (<BindGoogleAuthenticator />) : (<Navigate to="/login" replace />)} />

        {/* Backward-compatible URLs */}
        <Route path="/user_profile/passkey" element={<Navigate to="/user_profile/security/passkey" replace />} />
        <Route path="/user_profile/smsVerification" element={<Navigate to="/user_profile/security/smsVerification" replace />} />
        <Route path="/user_profile/emailVerification" element={<Navigate to="/user_profile/security/emailVerification" replace />} />
        <Route path="/user_profile/closeAccount" element={<Navigate to="/user_profile/security/closeAccount" replace />} />

        <Route path="/asset_managemnet" element={token ? (<SidebarDeposit userDetails={userDetails} />) : (<Navigate to="/login" replace />)} >
          <Route index path="deposit" element={token ? (<DepositPage userDetails={userDetails} />) : <Navigate to="/login" replace />} />
          <Route path="withdraw" element={token ? (<WithdrawPage userDetails={userDetails} />) : <Navigate to="/login" replace />} />
          <Route path="deposit_fiat" element={token ? <DepositFiatPage userDetails={userDetails} /> : <Navigate to="/login" replace />} />
          <Route path="fiat_account" element={<Navigate to="/asset_managemnet/deposit_fiat" replace />} />
          <Route path="withdraw_fiat" element={token ? <WithdrawFiatPage /> : <Navigate to="/login" replace />} />
          <Route path="fiat_activity" element={<Navigate to="/asset_managemnet/deposit_fiat" replace />} />
          <Route path="security_verification_unavailable" element={token ? (<SecurityVerificationUnavailable />) : <Navigate to="/login" replace />} />
        </Route>
        <Route path="/referal_list" element={token ? <RefrealList /> : <Navigate to="/login" replace />} />



        <Route exact path="/forgot_password" element={<ForgotPassword />} />
        <Route exact path="/reset_password" element={<ForgotPassword />} />
        <Route exact path="/login/reset" element={<ForgotPassword />} />
        <Route exact path="/signup" element={<SignupPage />} />
        <Route exact path="/account-verification/:authenticationToken" element={<Navigate to="/login" replace />} />
        <Route exact path="/account-activate/:authenticationToken" element={!token ? <RegistrationResult /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/login" element={!token ? <LoginPage /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/auth/verify" element={!token ? <LoginPage /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/market" element={<Market />} />
        {/* <Route exact path="/earning" element={<Earning />} /> */}
        <Route exact path="/simple-earn" element={<SimpleEarn />} />
        <Route exact path="/launchpad" element={<Launchpad />} />

        <Route exact path="/meme" element={<MemePage />} />
        <Route exact path="/trade/:pairs" element={<Trade />}></Route>
        <Route exact path="/margin" element={<Navigate to="/margin/BTC_USDT" replace />} />
        <Route exact path="/margin/:pairs" element={<Margin />} />
        <Route exact path="/cross" element={<Navigate to="/cross/BTC_USDT" replace />} />
        <Route exact path="/cross/:pairs" element={<CrossMargin />} />
        <Route exact path="/futures_trade" element={<Navigate to="/futures_trade/BTC_USDT" replace />} />
        <Route exact path="/futures_trade/:pairs" element={<FuturesTrade />} />
        <Route exact path="/options" element={<Navigate to="/options/BTC_USDT" replace />} />
        <Route exact path="/options/:pairs" element={<OptionsPage />} />
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/general-disclaimer" element={<GeneralDisclaimer />} />
        <Route exact path="/staking-user-agreement" element={<StakingUserAgreement />} />
        <Route exact path="/RiskDisclosure" element={<RiskDisclosure />} />
        <Route exact path="/TermsofUse" element={<Termsofuse />} />
        <Route exact path="/aml-kyc-policy" element={<AmlPolicy />} />
        <Route exact path="/blogs/:id" element={<BlogDetails />} />
        <Route exact path="/blogdetails" element={<RedirectToBlogDetails />} />
        <Route exact path="/PrivacyDataProtectionPolicy" element={<PrivacyDataProtectionPolicy />} />
        <Route exact path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route exact path="/complaints-handling-procedure" element={<ComplaintsHandlingProcedure />} />
        <Route exact path="/contact" element={<Contactus />} />
        <Route exact path="/fees" element={<FeesPage />} />
        <Route exact path="/bug-bounty" element={<BugBounty />} />
        <Route exact path="/bug_bounty" element={<Navigate to="/bug-bounty" replace />} />
        <Route exact path="/coin_list" element={<ListCoin />} />
        <Route exact path="/token" element={<TokenPage />} />
        <Route exact path="/referral" element={<ReferralPageNew />} />
        <Route exact path="/security_system" element={<SecuritySystem />} />
        <Route exact path="/blogs" element={<BlogList />} />
        <Route exact path="/about_us" element={<AboutUs />} />
        <Route exact path="/about_us/company" element={<AboutCompany />} />
        <Route exact path="/about_us/team" element={<AboutTeam />} />
        <Route exact path="/proof-of-reserves" element={<ProofOfReserves />} />
        <Route exact path="/help_center" element={<FAQ />} />
        <Route exact path="/help_center/:category" element={<FAQ />} />
        <Route exact path="/FAQ" element={<Navigate to="/help_center" replace />} />
        <Route exact path="/FAQ/:category" element={<RedirectToHelpCenter />} />
        <Route exact path="/FAQSidebar" element={<RedirectToFAQSidebar />} />
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/chart/:theme/:pairs" element={<MobileChart />} />
        <Route path="/futures-chart/:theme/:pairs" element={<MobileFuturesChart />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/announcement/details/:id" element={<Announcement />} />
        <Route path="/announcement/:category" element={<Announcement />} />
        <Route path="/launchpad" element={<LaunchpadHome />} />
        <Route path="/launchpad-detail" element={<LaunchpadDetail />} />
        <Route path="/launchpad-detail/:id" element={<LaunchpadDetail />} />
        <Route path="/launchpadCoin_Details/:id" element={<LaunchpadCoinPage />} />
        <Route path="/announcement_list/:title/:announce_title_id" element={<RedirectToAnnouncementList />} />
        <Route path="/announcement_details/:title/:announce_title_id" element={<RedirectToAnnouncementDetails />} />
        <Route path="/convert" element={<ConvertPage />} />
        <Route path="/buy_crypto" element={<BuySellPage />} />
        <Route path="/vip-services" element={<VipServices />} />
        <Route path="/vip-earning" element={<VipServices />} />
        {/* <Route path="/wait-list" element={<WaitList />} /> */}
        <Route path="/staking" element={<StakingPage />} />
        <Route path="/staking-detail" element={<StakingDetail />} />
        <Route path="/staking" element={<Navigate to="/staking" replace />} />
        <Route path="/soft-staking" element={<SoftStaking />} />
        <Route path="/copy-trading" element={<CopyTradingPage />} />
        <Route path="/copy_trading" element={<Navigate to="/copy-trading" replace />} />
        <Route path="/copy-trading-detail" element={<CopyTradingDetailPage />} />
        <Route path="/copy_trading_detail" element={<Navigate to="/copy-trading-detail" replace />} />
        <Route path="/copytrading-detail" element={<Navigate to="/copy-trading-detail" replace />} />
        <Route path="/copytrading" element={<Navigate to="/copy-trading" replace />} />

        {/* Footer Pages Redirects */}
        <Route exact path="/blog" element={<Navigate to="/blogs" replace />} />
        <Route exact path="/terms_conditions" element={<Navigate to="/TermsofUse" replace />} />
        <Route exact path="/spot_trading" element={<Navigate to="/trade/BTC_USDT" replace />} />
        <Route exact path="/margin_trading" element={<Navigate to="/margin/BTC_USDT" replace />} />
        <Route exact path="/convert_trading" element={<Navigate to="/convert" replace />} />
        <Route exact path="/referral_rewards" element={<Navigate to="/referral" replace />} />
        <Route exact path="/vip_benefits" element={<Navigate to="/vip-services" replace />} />
        <Route exact path="/Listing" element={<Navigate to="/coin_list" replace />} />
        <Route exact path="/crypto_market" element={<Navigate to="/market" replace />} />
        {/* <Route exact path="/earn" element={<Navigate to="/earning" replace />} /> */}
        <Route exact path="/blog_news" element={<Navigate to="/blogs" replace />} />
        <Route exact path="/deposit_crypto" element={<Navigate to="/asset_managemnet/deposit" replace />} />
        <Route exact path="/user_agreement" element={<UserAgreement />} />
        <Route exact path="/user_termsConditions" element={<UserTermsConditions />} />
        <Route exact path="/delete-account" element={<DeleteAccount />} />

        {/* Footer Missing Premium Pages */}
        <Route exact path="/careers" element={<CareersPage />} />
        <Route exact path="/new-security" element={<NewSecurity />} />
        <Route exact path="/license" element={<LicensePage />} />
        <Route exact path="/low_enforcement" element={<LawEnforcementPage />} />
        <Route exact path="/otc" element={<Navigate to="/" replace />} />
        <Route exact path="/otc-trade" element={<OtcTradeLanding />} />
        <Route exact path="/otc-trade/app" element={<Navigate to="/user_profile/orders/otc_trade?open=quote" replace />} />
        <Route exact path="/otc-trade/history" element={token ? (<OtcTradeHistory />) : (<Navigate to="/login" replace state={{ redirectTo: "/otc-trade/history" }} />)} />
        <Route exact path="/otc/rfq" element={<Navigate to="/" replace />} />
        <Route exact path="/otc/history" element={<Navigate to="/" replace />} />
        <Route exact path="/otc_desk" element={<Navigate to="/" replace />} />
        <Route exact path="/otc-desk" element={<Navigate to="/" replace />} />
        <Route exact path="/otc_desk/rfq" element={<Navigate to="/" replace />} />
        <Route exact path="/otc-desk/rfq" element={<Navigate to="/" replace />} />
        <Route exact path="/otc_service" element={<Navigate to="/" replace />} />
        <Route exact path="/otc-service" element={<Navigate to="/" replace />} />
        <Route exact path="/square" element={<SquarePage />} />
        <Route exact path="/air_drop" element={<AirDropPage />} />
        <Route exact path="/airdrops" element={<AirDropPage />} />
        <Route exact path="/airdrop-detail" element={<AirdropDetails />} />
        <Route exact path="/airdrops/detail" element={<AirdropDetails />} />
        <Route exact path="/air_drop/detail" element={<AirdropDetails />} />
        <Route exact path="/user_feedback" element={<UserFeedbackPage />} />
        <Route exact path="/submit_request" element={<SubmitRequestPage />} />
        <Route exact path="/developers" element={<DevelopersPage />} />
        <Route exact path="/affiliate_program" element={<AffiliateProgramPage />} />
        <Route exact path="/why_agcx" element={<WhyAgcePage />} />
        <Route exact path="/why_agce" element={<Navigate to="/why_agcx" replace />} />
        <Route exact path="/download_app" element={<DownloadAppPage />} />
        <Route exact path="/kyb" element={<KYBVerification />} />
        <Route exact path="/earn-new" element={<EarnNewPage />} />
        <Route exact path="/straight" element={<StraightPage />} />
        <Route exact path="/financial-institution" element={<FinancialInstitution />} />
        <Route exact path="/financial_institution" element={<FinancialInstitution />} />
        <Route exact path="/financial-institutions" element={<FinancialInstitution />} />
        <Route exact path="/infrastructure" element={<Infrastructure />} />

        {/* P2P Routes */}
        <Route path="/p2p-dashboard" element={token ? <P2pDashboard /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-order-details/:adId" element={token ? <P2pOrderDetails /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-create-post" element={token ? <P2pCreatePost /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-my-ads" element={token ? <P2pMyAds /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-orders" element={token ? <P2pOrders /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-profile" element={token ? <P2pProfile /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-trade-order" element={token ? <P2pTradeOrder /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-order" element={token ? <P2pTradeOrder /> : <Navigate to="/login" replace />} />

        <Route path="/*" element={<ComingSoonPage />} />
      </Routes>
      {(location.pathname === '/' || location.pathname.startsWith('/about_us')) && <Footer />}
    </>
  );
}

export default Routing;
